export class PrefillFormFields {
    constructor(form) {
        this.form = form;
        this.init();
    }

    init() {
        if (!this.form) {
            return;
        }

        this.urlParams = this.getURLParams();

        setTimeout(() => {
            this.fillFormWithParams();
        }, 1000);
    }

    getURLParams() {
        const searchParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(searchParams.entries());
    }

    fillFormWithParams() {
        for (const param in this.urlParams) {
            let inputField = this.form.querySelector(`[id*="${param}"]`);
            if (!inputField) {
                const paramName = param.toLowerCase().replace(/\s/g, '_');
                const labelForParam = Array.from(this.form.querySelectorAll('label')).find(label => {
                    const labelName = label.textContent.trim().toLowerCase().replace(/\s+\*$/, '').replace(/\s/g, '_');
                    return labelName === paramName;
                });
                if (labelForParam) {
                    inputField = labelForParam.nextElementSibling;
                }
            }

            if (!inputField) continue;

            if (inputField && inputField.tagName === 'INPUT') {
                inputField.defaultValue = this.urlParams[param];
                inputField.dispatchEvent(new Event('input', { bubbles: true }));
            }

            if (inputField.tagName === 'SELECT') {
                const optionTextToPrefill = this.urlParams[param].toLowerCase().replace(/\s/g, '_');
                const optionValueToPrefill = this.urlParams[param].toLowerCase().replace(/\s/g, '_');
                const options = inputField.querySelectorAll('option');

                options.forEach(option => {
                    const optionText = option.textContent.trim().toLowerCase().replace(/\s/g, '_');
                    const optionValue = option.value.toLowerCase().replace(/\s/g, '_');

                    if (optionText === optionTextToPrefill || optionValue === optionValueToPrefill) {
                        option.selected = true;
                        inputField.dispatchEvent(new Event('change', {bubbles: true}));
                    }
                });
            }
        }
    }

    activatePrefill() {
        this.init();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const suluForms = Array.from(document.querySelectorAll('form.sulu-form'));
    suluForms.forEach((form) => { new PrefillFormFields(form); });
});

export function activatePrefillScript(forms) {
    forms.forEach((form) => {
        const prefillFormFields = new PrefillFormFields(form);
        prefillFormFields.activatePrefill();
    });
}
